export const getStatusColor = (status) => {
    const statusColors = {
        Todo: {
            bg: "#E3F2FD",
            color: "#0D47A1",
            border: "#90CAF9"
        },
        Open: {
            bg: "#E3F2FD",
            color: "#1565C0",
            border: "#64B5F6"
        },
        "In Progress": {
            bg: "#FFF3E0",
            color: "#EF6C00",
            border: "#FFB74D"
        },
        Ongoing: {
            bg: "#E1F5FE",
            color: "#0277BD",
            border: "#4FC3F7"
        },
        Completed: {
            bg: "#E8F5E9",
            color: "#2E7D32",
            border: "#81C784"
        },
        "Re Open": {
            bg: "#FCE4EC",
            color: "#C2185B",
            border: "#F48FB1"
        },
        Hold: {
            bg: "#F5F5F5",
            color: "#616161",
            border: "#BDBDBD"
        },
        Overdue: {
            bg: "#FFEBEE",
            color: "#C62828",
            border: "#EF9A9A"
        },
        Cancelled: {
            bg: "#ECEFF1",
            color: "#455A64",
            border: "#B0BEC5"
        },
        Pending: {
            bg: "#FFF8E1",
            color: "#F9A825",
            border: "#FFE082"
        },
        Approved: {
            bg: "#E0F2F1",
            color: "#00796B",
            border: "#80CBC4"
        },
        Rejected: {
            bg: "#FFEBEE",
            color: "#D32F2F",
            border: "#EF9A9A"
        },
        "In Review": {
            bg: "#EDE7F6",
            color: "#512DA8",
            border: "#B39DDB"
        },
        Testing: {
            bg: "#E0F7FA",
            color: "#00838F",
            border: "#80DEEA"
        },
        Blocked: {
            bg: "#FBE9E7",
            color: "#D84315",
            border: "#FFAB91"
        },
        "On Track": {
            bg: "#E8F5E9",
            color: "#1B5E20",
            border: "#66BB6A"
        },
        "At Risk": {
            bg: "#FFF3E0",
            color: "#E65100",
            border: "#FFB74D"
        },
        "Not Started": {
            bg: "#F3E5F5",
            color: "#6A1B9A",
            border: "#CE93D8"
        },
        Deferred: {
            bg: "#F1F8E9",
            color: "#558B2F",
            border: "#AED581"
        },
        "Submitted a goal": {
            bg: "#E8EAF6",
            color: "#3F51B5",
            border: "#9FA8DA"
        },
        Active: {
            bg: "#E8F5E9",
            color: "#2E7D32",
            border: "#81C784"
        },
        Inactive: {
            bg: "#FFEBEE",
            color: "#C62828",
            border: "#EF9A9A"
        },
        Backlog: {
            bg: "#F3F4F6",
            color: "#374151",
            border: "#D1D5DB"
        },
        "Ready for Dev": {
            bg: "#FEF3C7",
            color: "#92400E",
            border: "#FCD34D"
        },
        "In Development": {
            bg: "#DBEAFE",
            color: "#1E40AF",
            border: "#93C5FD"
        },
    };

    return statusColors[status] || {
        bg: "#ECEFF1",
        color: "#37474F",
        border: "#B0BEC5"
    };
};

export const priorityColors = {
    Low: {
        bg: "#E8F5E9",
        color: "#2E7D32",
        border: "#81C784"
    },
    Medium: {
        bg: "#FFF3E0",
        color: "#EF6C00",
        border: "#FFB74D"
    },
    High: {
        bg: "#FFEBEE",
        color: "#C62828",
        border: "#EF9A9A"
    }
};

export const issueTypeColors = {
    Bug: {
        bg: "#FFEBEE",
        color: "#C62828",
        border: "#EF9A9A"
    },
    Enhancement: {
        bg: "#E3F2FD",
        color: "#1565C0",
        border: "#64B5F6"
    },
    Feature: {
        bg: "#E8F5E9",
        color: "#2E7D32",
        border: "#81C784"
    }
};

export const getAvatarColor = (name) => {
    const colors = [
        { bg: '#2563eb', border: '#1d4ed8' },
        { bg: '#7c3aed', border: '#6d28d9' },
        { bg: '#db2777', border: '#be185d' },
        { bg: '#ea580c', border: '#c2410c' },
        { bg: '#16a34a', border: '#15803d' },
        { bg: '#0891b2', border: '#0e7490' },
        { bg: '#4f46e5', border: '#4338ca' },
    ];

    if (!name) return colors[0];

    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }

    return colors[Math.abs(hash) % colors.length];
};